<template>
  <div class="p-4 bg-faded logowanie">
    <div class="row">
      <div class="col-sm-12">
        <h1 class="h1 text-left fw-700 mb-4 d-xs-block d-none">
          Logowanie
        </h1>
      </div>
    </div>

    <div v-if="!showLocalForm" class="row">
      <div class="col-sm-12">
        <p class="h3 mb-5 text-center">
          Dla uczniów/rodziców posiadających konto w Lubelskim Portalu Oświatowym, pracowników Urzędu Miejskiego w
          Lublinie oraz pracowników placówek oświatowych
        </p>

        <p class="text-uppercase">
          <a class="btn btn-info btn-block btn-lg" :href="ssoLoginUrl">
            Logowanie przez Zintegrowany System Oświatowy dla&nbsp;Jednostek Oświatowych Miasta Lublin
          </a>
        </p>
      </div>

      <div v-if="loginEnabled" class="col-sm-12 mt-5">
        <p class="h3 mb-5 text-center">Dla osób nieposiadających konta w Lubelskim Portalu Oświatowym</p>

        <p class="text-uppercase">
          <a class="btn btn-primary btn-block btn-lg pointer" href="javascript:void(0)" @click="showLocalForm = true">
            ZALOGUJ SIĘ
          </a>
        </p>

        <p class="h3 text-center mb-3">Jeżeli nie posiadasz jeszcze konta</p>

        <p class="text-uppercase">
          <router-link class="btn btn-primary btn-block btn-lg pointer" :to="{ name: 'register' }">
            ZAREJESTRUJ SIĘ
          </router-link>
        </p>
      </div>
    </div>

    <div v-else class="row">
      <div class="col-sm-12">
        <a class="pointer label text-uppercase" href="javascript:void(0)" @click.prevent="showLocalForm = false">
          [ Powrót do wyboru formy logowania ]
        </a>
      </div>

      <div class="col-sm-12">
        <h1 class="h1 text-left fw-700 my-4 d-xs-block">
          Logowanie
        </h1>

        <form>
          <div class="form-group">
            <w-input disable-tooltip :model="$schema.login" :placeholder="$schema.login.$description" />
          </div>

          <div class="form-group">
            <w-input
              type="password"
              disable-tooltip
              :model="$schema.password"
              :placeholder="$schema.password.$description"
            />
          </div>

          <div class="row no-gutters">
            <div class="col-lg-12 pl-lg-1 my-2 text-center">
              <button aria-label="zaloguj się" class="btn btn-primary btn-block btn-lg" @click.prevent="submit()">
                ZALOGUJ SIĘ
              </button>
            </div>
          </div>
        </form>

        <div class="mx-1 my-1 text-center label">
          <router-link :to="{ name: 'reset' }" class="reset-link">
            [ ZAPOMNIAŁEM HASŁA ]
          </router-link>
        </div>

        <div class="mx-1 my-1 text-center label">
          <router-link :to="{ name: 'register' }" class="reset-link">
            [ ZAREJESTRUJ SIĘ ]
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from '@/enums/errors.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/login.schema';
import { config } from '@/utils/config';
import { redirectAfterLogin } from '@/utils/redirectAfterLogin';

// @vuese
// Formularz logowania
// @group Forms
export default {
  name: 'Login',
  mixins: [formMixin, notificationsMixin],
  external: {},
  data() {
    return {
      ssoLoginUrl: config.ssoLoginURL,
      list: [],
      model: {},
      showLocalForm: false
    };
  },
  schema,
  computed: {
    loginEnabled() {
      return !config.loginDisabled;
    }
  },
  beforeMount() {
    this.$store.dispatch('auth/logout');
  },
  methods: {
    async submit() {
      if (!this.$schema.$validateAll().length) {
        this.$store
          .dispatch('auth/login', this.model)
          .then(() => redirectAfterLogin())
          .catch(() => this.notifyError(Errors.AUTH_INCORRECT_LOGIN));
      }
    }
  }
};
</script>

<style scoped>
.btn.btn-info {
  color: white;
  text-transform: uppercase;
  font-weight: 600;
}
.btn.btn-danger,
.btn.btn-primary {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 1.2rem;
  color: black;
}
.logowanie .label {
  font-size: 1rem;
  font-weight: 600;
}
.logowanie:after {
  content: '';
  background-color: #6fbe41;
  width: 60px;
  height: 15px;
  position: absolute;
  top: 0;
  right: 12px;
}
.logowanie::before {
  content: '';
  background-color: #6fbe41;
  width: 15px;
  height: 38px;
  position: absolute;
  top: 0;
  right: 12px;
}
.reset-link:focus {
  background: #666;
  color: #fff;
}
</style>
